module.exports = {"id":"dp2_2l5q3","category":"2.2","text":"Digital Sharing","instructions":"You should always attribute ownership of information that you share online if it is not your own","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"questionType":"PickOne","random":false,"options":[{"id":"dp2_2l5q3-a1","text":"True","score":5.6},{"id":"dp2_2l5q3-a2","text":"Not sure","score":3.4},{"id":"dp2_2l5q3-a3","text":"False","score":3.4}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l5q3.json
// module id = 1024
// module chunks = 41